import { useStore } from '@/state/store';
import type { Theme } from '@/types';

const NEXT: Record<Theme, Theme> = { light: 'dark', dark: 'system', system: 'light' };
const LABEL: Record<Theme, string> = { light: '☀️ Light', dark: '🌙 Dark', system: '🖥️ System' };

/** Cycles light → dark → system; the class is applied by App's theme effect. */
export function ThemeToggle() {
  const theme = useStore((s) => s.ui.theme);
  const setUi = useStore((s) => s.setUi);
  return (
    <button
      type="button"
      onClick={() => void setUi({ theme: NEXT[theme] })}
      className="rounded-md border border-slate-300 px-2 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800"
      aria-label={`Theme: ${theme}. Click to change.`}
    >
      {LABEL[theme]}
    </button>
  );
}
